const DEFAULT_SUGGESTIONS = [
  {
    label: "ALL",
    top_cities: {
      label: "Top Cities",
      data: [
        {
          id: 14,
          name: "London",
          name_zh: "伦敦",
          canonical_name: "london-1811028205760",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/14/2c73a731.jpg",
        },
        {
          id: 994,
          name: "Dublin",
          name_zh: "都柏林",
          canonical_name: "dublin-1811234255126",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/994/805dad3f.jpg",
        },
        {
          id: 10,
          name: "Melbourne",
          name_zh: "墨尔本",
          canonical_name: "melbourne-1811011846366",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/10/7714eb17.jpg",
        },
        {
          id: 1744,
          name: "Toronto",
          name_zh: "多伦多",
          canonical_name: "toronto-1912205118632",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1744/10f2d704.jpg",
        },
        {
          id: 56,
          name: "Manchester",
          name_zh: "曼彻斯特",
          canonical_name: "manchester-1811021510595",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/56/65e8b9b2.jpg",
        },
        {
          id: 67,
          name: "Birmingham",
          name_zh: "伯明翰",
          canonical_name: "birmingham-1811028953945",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/67/e256aee0.jpg",
        },
        {
          id: 9,
          name: "Sydney",
          name_zh: "悉尼",
          canonical_name: "sydney-1811019193619",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/9/c6cf695e.jpg",
        },
        {
          id: 490,
          name: "Chicago",
          name_zh: "芝加哥",
          canonical_name: "chicago-1811055213730",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/490/18e9a2ab.jpg",
        },
        {
          id: 1572,
          name: "Cork",
          name_zh: "科克",
          canonical_name: "cork-1905110396319",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1572/865018f4.jpg",
        },
        {
          id: 34,
          name: "Nottingham",
          name_zh: "诺丁汉",
          canonical_name: "nottingham-1811025104223",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/34/a1c38c48.jpg",
        },
      ],
    },
  },
  {
    id: 14,
    country_full_name: "United Kingdom",
    country_short_name: "GB",
    country_alias: "UK",
    country_flag_image: "flag-uk.svg",
    top_cities: {
      label: "Top Cities in United Kingdom",
      data: [
        {
          id: 14,
          name: "London",
          name_zh: "伦敦",
          canonical_name: "london-1811028205760",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/14/2c73a731.jpg",
        },
        {
          id: 56,
          name: "Manchester",
          name_zh: "曼彻斯特",
          canonical_name: "manchester-1811021510595",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/56/65e8b9b2.jpg",
        },
        {
          id: 67,
          name: "Birmingham",
          name_zh: "伯明翰",
          canonical_name: "birmingham-1811028953945",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/67/e256aee0.jpg",
        },
        {
          id: 34,
          name: "Nottingham",
          name_zh: "诺丁汉",
          canonical_name: "nottingham-1811025104223",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/34/a1c38c48.jpg",
        },
        {
          id: 55,
          name: "Liverpool",
          name_zh: "利物浦",
          canonical_name: "liverpool-1811029039831",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/55/e0e0ad9a.jpg",
        },
        {
          id: 75,
          name: "Leicester",
          name_zh: "莱斯特",
          canonical_name: "leicester-1811027154774",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/75/4845618d.jpg",
        },
        {
          id: 38,
          name: "Glasgow",
          name_zh: "格拉斯哥",
          canonical_name: "glasgow-1811024356803",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/38/ffa1a852.jpg",
        },
        {
          id: 32,
          name: "Newcastle upon Tyne",
          name_zh: "纽卡斯尔",
          canonical_name: "newcastle-upon-tyne-1811022588361",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/32/22441ccc.jpg",
        },
      ],
    },
  },
  {
    id: 994,
    country_full_name: "Ireland",
    country_short_name: "IE",
    country_alias: "IRE",
    country_flag_image: "flag-ire.svg",
    top_cities: {
      label: "Top Cities in Ireland",
      data: [
        {
          id: 994,
          name: "Dublin",
          name_zh: "都柏林",
          canonical_name: "dublin-1811234255126",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/994/805dad3f.jpg",
        },
        {
          id: 1572,
          name: "Cork",
          name_zh: "科克",
          canonical_name: "cork-1905110396319",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1572/865018f4.jpg",
        },
        {
          id: 1769,
          name: "Galway",
          name_zh: "戈尔韦",
          canonical_name: "galway-2002183066399",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1769/98d6d3e1.jpg",
        },
      ],
    },
  },
  {
    id: 1744,
    country_full_name: "Canada",
    country_short_name: "CA",
    country_alias: "CAN",
    country_flag_image: "flag-can.svg",
    top_cities: {
      label: "Top Cities in Canada",
      data: [
        {
          id: 1744,
          name: "Toronto",
          name_zh: "多伦多",
          canonical_name: "toronto-1912205118632",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1744/10f2d704.jpg",
        },
        {
          id: 1728,
          name: "Montreal",
          name_zh: "蒙特利尔",
          canonical_name: "montreal-1911254462968",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1728/b4ddfc10.jpg",
        },
        {
          id: 1710,
          name: "Vancouver",
          name_zh: "温哥华",
          canonical_name: "vancouver-1911021542675",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1710/8a743016.jpg",
        },
        {
          id: 2121,
          name: "Ottawa",
          name_zh: "渥太华",
          canonical_name: "ottawa-2304201785556",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2121/1443aafc.jpg",
        },
        {
          id: 2134,
          name: "Oshawa",
          name_zh: "奥沙瓦",
          canonical_name: "oshawa-2305027773445",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2134/f6753c5f.jpg",
        },
        {
          id: 2447,
          name: "Waterloo",
          name_zh: "滑铁卢",
          canonical_name: "waterloo-2402226880061",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2447/c123cfd0.jpg",
        },
      ],
    },
  },
  {
    id: 10,
    country_full_name: "Australia",
    country_short_name: "AU",
    country_alias: "AUS",
    country_flag_image: "flag-aus.svg",
    top_cities: {
      label: "Top Cities in Australia",
      data: [
        {
          id: 10,
          name: "Melbourne",
          name_zh: "墨尔本",
          canonical_name: "melbourne-1811011846366",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/10/7714eb17.jpg",
        },
        {
          id: 9,
          name: "Sydney",
          name_zh: "悉尼",
          canonical_name: "sydney-1811019193619",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/9/c6cf695e.jpg",
        },
        {
          id: 178,
          name: "Brisbane",
          name_zh: "布里斯班",
          canonical_name: "brisbane-1811022382320",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/178/3c2a6860.jpg",
        },
        {
          id: 180,
          name: "Perth",
          name_zh: "珀斯",
          canonical_name: "perth-1811021246766",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/180/6cb99543.jpg",
        },
        {
          id: 175,
          name: "Adelaide",
          name_zh: "阿德莱德",
          canonical_name: "adelaide-1811022271790",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/175/9d1f9d4d.jpg",
        },
        {
          id: 177,
          name: "Canberra",
          name_zh: "堪培拉",
          canonical_name: "canberra-1811028680774",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/177/e6622d59.jpg",
        },
        {
          id: 518,
          name: "Gold Coast",
          name_zh: "黄金海岸",
          canonical_name: "gold-coast-1811055204067",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/518/7d819ae6.jpg",
        },
      ],
    },
  },
  {
    id: 490,
    country_full_name: "United States",
    country_short_name: "US",
    country_alias: "USA",
    country_flag_image: "flag-usa.svg",
    top_cities: {
      label: "Top Cities in United States",
      data: [
        {
          id: 490,
          name: "Chicago",
          name_zh: "芝加哥",
          canonical_name: "chicago-1811055213730",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/490/18e9a2ab.jpg",
        },
        {
          id: 734,
          name: "New York",
          name_zh: "纽约",
          canonical_name: "new-york-city-1811153579499",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/734/ce559939.jpg",
        },
        {
          id: 422,
          name: "Houston",
          name_zh: "休斯顿",
          canonical_name: "houston-1811053554207",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/422/a4d5659f.jpg",
        },
        {
          id: 498,
          name: "Los Angeles",
          name_zh: "洛杉矶",
          canonical_name: "los-angeles-1811059549842",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/498/e04d6b55.jpg",
        },
        {
          id: 778,
          name: "Washington",
          name_zh: "华盛顿",
          canonical_name: "washington-dc-1811157116879",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/778/65596456.jpg",
        },
        {
          id: 426,
          name: "Austin",
          name_zh: "奥斯丁",
          canonical_name: "austin-1811059470166",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/426/01cd3666.jpg",
        },
        {
          id: 1076,
          name: "San Francisco",
          name_zh: "旧金山",
          canonical_name: "san-francisco-1811261246298",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1076/8a62a343.jpg",
        },
        {
          id: 492,
          name: "Boston",
          name_zh: "波士顿",
          canonical_name: "boston-1811058601037",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/492/0512dd8d.jpg",
        },
      ],
    },
  },
  {
    id: 1735,
    country_full_name: "Germany",
    country_short_name: "DE",
    country_alias: "GER",
    country_flag_image: "flag-ger.svg",
    top_cities: {
      label: "Top Cities in Germany",
      data: [
        {
          id: 1735,
          name: "Berlin",
          name_zh: "柏林",
          canonical_name: "berlin-1911262002763",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1735/f1070765.jpg",
        },
        {
          id: 1826,
          name: "Hamburg",
          name_zh: "汉堡",
          canonical_name: "hamburg-2010057120842",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1826/b8625a97.jpg",
        },
        {
          id: 1736,
          name: "Munich",
          name_zh: "慕尼黑",
          canonical_name: "munich-1911268823914",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1736/6c75f7e9.jpg",
        },
        {
          id: 1734,
          name: "Frankfurt",
          name_zh: "法兰克福",
          canonical_name: "frankfurt-1911264093661",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1734/423cd1f7.jpg",
        },
        {
          id: 1815,
          name: "Nuremberg",
          name_zh: "纽伦堡",
          canonical_name: "nuremberga-2009266934424",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1815/f96b3e63.jpg",
        },
        {
          id: 1808,
          name: "Cologne",
          name_zh: "科隆",
          canonical_name: "cologne-2009264907273",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1808/c0dde653.jpg",
        },
      ],
    },
  },
  {
    id: 1831,
    country_full_name: "Spain",
    country_short_name: "ES",
    country_alias: "ESP",
    country_flag_image: "flag-esp.svg",
    top_cities: {
      label: "Top Cities in Spain",
      data: [
        {
          id: 1831,
          name: "Madrid",
          name_zh: "马德里",
          canonical_name: "madrid-2010152201808",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1831/7b163745.jpg",
        },
        {
          id: 1836,
          name: "Barcelona",
          name_zh: "巴塞罗那",
          canonical_name: "barcelona-2011053744668",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1836/0c78706b.jpg",
        },
        {
          id: 2187,
          name: "Pamplona",
          name_zh: "潘普洛纳",
          canonical_name: "pamplona-2311027618669",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2187/f6cd6fce.jpg",
        },
        {
          id: 2122,
          name: "Málaga",
          name_zh: "马拉加",
          canonical_name: "malaga-2304262869306",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2122/ba09d762.jpg",
        },
        {
          id: 1946,
          name: "Seville",
          name_zh: "塞维利亚",
          canonical_name: "seville-2208080831405",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1946/4058a29b.jpg",
        },
        {
          id: 1832,
          name: "Valencia",
          name_zh: "瓦伦西亚",
          canonical_name: "valencia-2010151704940",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/1832/e307a64c.jpg",
        },
        {
          id: 2194,
          name: "Granada",
          name_zh: "格拉纳达",
          canonical_name: "granada-2401025559952",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2194/e7240a39.jpg",
        },
        {
          id: 2041,
          name: "Alcala de Henares",
          name_zh: "阿尔卡拉-德-埃纳雷斯",
          canonical_name: "alcala-de-henares-2210071885832",
          region_type: "locality",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com/regions/2041/8c2e8479.jpg",
        },
      ],
    },
  },
  {
    id: 1712,
    country_full_name: "New Zealand",
    country_short_name: "NZ",
    country_alias: "NZ",
    country_flag_image: "flag-nz.svg",
    top_cities: {
      label: "Top Cities in New Zealand",
      data: [
        {
          id: 1712,
          name: "Auckland",
          name_zh: "奥克兰",
          canonical_name: "auckland-1911021078582",
          region_type: "locality",
        },
        {
          id: 1714,
          name: "Wellington",
          name_zh: "惠灵顿",
          canonical_name: "wellington-1911020902254",
          region_type: "locality",
        },
      ],
    },
  },
  {
    id: 1730,
    country_full_name: "France",
    country_short_name: "FR",
    country_alias: "FRA",
    country_flag_image: "flag-france.svg",
    top_cities: {
      label: "Top Cities in France",
      data: [
        {
          id: 1730,
          name: "Paris",
          name_zh: "巴黎",
          canonical_name: "paris-1911265935013",
          region_type: "locality",
        },
      ]
    },
  },
  {
    id: 1836,
    country_full_name: "Singapore",
    country_short_name: "SG",
    country_alias: "SIN",
    country_flag_image: "flag-singapore.svg",
    top_cities: {
      label: "Top Cities in Singapore",
      data: [
        {
          id: 1836,
          name: "Singapore",
          name_zh: "新加坡",
          canonical_name: "singapore-2506022501650",
          region_type: "locality",
        },
      ],
    },
  },
  // {
  //   id: 1719,
  //   country_full_name: "United Arab Emirates",
  //   country_short_name: "AE",
  //   country_alias: "UAE",
  //   country_flag_image: "flag-uae.svg",
  //   top_cities: {
  //     label: "Top Cities in UAE",
  //     data: [
  //       {
  //         id: 1719,
  //         name: "Dubai",
  //         name_zh: "迪拜",
  //         canonical_name: "dubai-1911024693626",
  //         region_type: "locality",
  //       },
  //     ],
  //   },
  // },
];

export default DEFAULT_SUGGESTIONS;
